import Vuex from 'vuex'
import Vue from 'vue'
import createPersistedState from 'vuex-persistedstate'
Vue.use(Vuex)

const Store = new Vuex.Store({
  plugins: [createPersistedState({
    storage: window.localStorage,
    reducer(val) {
      return {
        // 只储存state中的user
        search_num: val.search_num,
        uid: val.uid,
        requestParams: val.requestParams,
        platform: val.platform,
        standalone: val.standalone,
        platformH5: val.platformH5,
        pay_platform: val.pay_platform
      }
    }
  })],
  state: {
    uid: 0,
    search_num: 1,
    // sendRequestParamsCallback SDK传回来的请求参数
    requestParams: {
      channel: '1', // 海南日常=0 ,常州中科=1, 旭扬=2 （隐私条款和用户协议区分）
      equmentid: '8554ee6dcc0b1d44', // 客户端设备号（imei、idfa）
      lid: '0', // 包链接id
      phone_manufacturer: 'Xiaomi', // 手机品牌
      equmentidfv: '922eab3f-4bda-481c-8812-61ba60ceb19d', // 客户端重装标识
      phone_ip: '192.168.0.106', // 手机Ip
      phone_resolution: 1080 * 2293, // 手机分辩率
      versionName: '1.0.0', // 版本名称
      phone_version: 10, // 手机系统版本
      mac: '02:00:00:00:00:00', // mac地址
      versionCode: '1.0', // 代码版本号
      phone_model: 'M2007J17C', // 手机模式||机型
      gid: '0', // 游戏id
      package_id: '0', // 包id
      subchannelnum: '0', // 广告商分包id
      devicesName: '', // 设备的名称
      userAgent: '', // 设备的UA
      osType: 'android', // 设备的系统类型
      oaid: '567b8259681a8caa', // 设备id
      imei: '00000000-0000-0000-0000-000000000000',
      devicesdisplay: '',
      isWechatAppInstalled: 1, // 微信 0-没有下载微信客户端 1-有
      isAliAppInstalled: 1, // 支付宝 0-没有下载支付宝客户端 1-有
      IsEmulator: 0, // 模拟器 1-当前环境为模拟器 0-不是模拟器
      version: '1.0.0', // 版本号
      is_link: 0, // ios盒子网页版是否是链接传的lid
      package_type: 0// 广告平台 //2-巨量包 0-官包
    },
    platform: 0,
    standalone: false, // ios-页面是否在桌面主屏幕打开 true-是 false-否-在浏览器打开
    platformH5: false, // 是否是安卓浏览器打开的
    pay_platform: 0, // 支付专用platform
    phone_ip: 0, // 网络ip
    liveParams: {
      pull_url: '', //
      SDKAppID: '', //
      userSig: '', //
      im_group: '',
      roomId: ''
    },
    liveBoxShow: false,
    playing: false,
    glo_currentTime: 0,
    audio: false,
    glo_roomId: 0,
    playGid: 0,
    navHeight: 0,
    imgRandom: Math.random(),
    bgRandom: Math.random(),
    select_sub_uid: {}, // 切换小号
    sign_in: false, // 签到
    sign_red: false, // 签到红点
    sdk_gid: 0// SDK跳转盒子携带的gid
  },
  mutations: {
    handelUid(state, uid) {
      state.uid = uid
    },
    handelRequestParams(state, requestParams) {
      state.requestParams = requestParams
    },
    handelPlatform(state, platform) {
      state.platform = platform
    },
    handelStandalone(state, standalone) {
      state.standalone = standalone
    },
    handelPlatformH5(state, platformH5) {
      state.platformH5 = platformH5
    },
    handelPay_platform(state, payPlatform) {
      state.pay_platform = payPlatform
    },
    handelLiveParams(state, liveParams) {
      state.liveParams = liveParams
    },
    handelLiveBoxShow(state, liveBoxShow) {
      state.liveBoxShow = liveBoxShow
    },
    handelPlaying(state, playing) {
      state.playing = playing
    },
    handelCurrentTime(state, gloCurrentTime) {
      state.glo_currentTime = gloCurrentTime
    },
    handelAudio(state, audio) {
      state.audio = audio
    },
    handelPlayGid(state, playGid) {
      state.playGid = playGid
    },
    handelRoomId(state, gloRoomId) {
      state.glo_roomId = gloRoomId
    },
    handelNavHeight(state, navHeight) {
      state.navHeight = navHeight
    },
    handleImgRandom(state, imgRandom) {
      state.imgRandom = imgRandom
    },
    handleBgRandom(state, bgRandom) {
      state.bgRandom = bgRandom
    },
    handelSelectSubUid(state, payload) {
      state.select_sub_uid = { ...state.select_sub_uid, ...payload }
    },
    clearLoggedInUser(state) {
      state.select_sub_uid = null
    },
    handelSignIn(state, signIn) {
      state.sign_in = signIn
    },
    handelSignRed(state, signRed) {
      state.sign_red = signRed
    },
    handelPhoneIp(state, phoneIp) {
      state.phone_ip = phoneIp
    },
    handelSdkGid(state, sdkGid) {
      state.sdk_gid = sdkGid
    }
  }
})
export default Store
